export const markObsoleteFavoritesAsDeprecated = (state) => {
  state.favourites.map((favourite) => {
    favourite.deprecated = true;

    return favourite;
  });

  return state;
};
